import { useSelector } from 'react-redux';
import { useMemo } from 'react';
import { retrieveThirdPartyData } from 'utils/manipulatePartnerSponsor';

/**
 * 取得 ThirdParty 資料 Hook
 * @param {Object} param - 參數物件
 * @param {Object} [param.partner={}] - partner 資料
 * @param {Object} [param.sponsor={}] - sponsor 資料
 * @param {string|Array<string>} [param.platform] - 搜尋的平台
 * @param {boolean} [param.isComparePartner=true] - 是否要取得 Partner 資料
 * @param {boolean} [param.isCheckCustomSocialLogin=true] - 是否要檢查 Plan
 * @returns {Object} - 包含對應平台在 ThirdParty 中資料的物件
 */
export default function useRetrieveThirdPartyData({
    partner,
    sponsor,
    platform,
    isComparePartner = true,
    isCheckCustomSocialLogin = true
}) {
    const reduxSponsor = useSelector(s => s.sponsor);
    const reduxPartner = useSelector(s => s.partner);
    const editorPlanItems = useSelector(s => s.availPlanItems);
    const clientPlanItems = useSelector(s => s.settingPlan);

    return useMemo(() => {
        const curSponsor = sponsor || reduxSponsor;
        const curPartner = partner || reduxPartner;
        const planItems = editorPlanItems || clientPlanItems;

        return retrieveThirdPartyData({
            partner: curPartner,
            sponsor: curSponsor,
            planItems,
            platform,
            isComparePartner,
            isCheckCustomSocialLogin
        });
    }, [
        partner,
        sponsor,
        platform,
        isComparePartner,
        isCheckCustomSocialLogin,
        reduxSponsor,
        reduxPartner,
        editorPlanItems,
        clientPlanItems
    ]);
}
